import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

export default class SurveyTransferMappingSearchParams extends SearchParamsBase {
  initialize() {
    // Default: show active mappings only. Clearing it shows active + inactive.
    this.IsActive = 'false';
    this.ClientNameOrId = '';
    this.SourceSurvey = '';
    this.TargetSurvey = '';
  }

  static iconName = 'fa-solid fa-search';
  static saveType = 'SurveyTransferMappingSearchParams';

  static fieldsInSearchBox = [
    { fieldName: 'IsActive', label: 'Is Active', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
    { fieldName: 'ClientNameOrId', label: 'Client Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'SourceSurvey',
      label: 'Source Survey (name or 3rd-party id)',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'TargetSurvey',
      label: 'Target Survey (name or 3rd-party id)',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
  ];

}
